import React from 'react';
import { Flex} from "antd";
import {StyledCard} from "./SubCategoryPopup.styled";
import style from "./SubCategoryPopup.module.scss";
import {IoShieldCheckmark} from "react-icons/io5";
import {CategoryListCardProps, SubCategoryPopupCardProps} from "../../models";
import {FaChevronLeft} from "react-icons/fa6";
import {useNavigate} from "react-router-dom";

const SubCategoryCard = ({data,onCategoryClick}: CategoryListCardProps) => {
const navigate = useNavigate()
    return (
        <StyledCard onClick={() => onCategoryClick(data?.subCategoryId)}
        >
            <Flex justify={"space-between"} align={"center"}>
                <span> {data?.name} </span>
                {data.subSubCategories && <span> <FaChevronLeft className={style.icons}/> </span>}

            </Flex>
        </StyledCard>
    );
};

export default SubCategoryCard;